import * as React from "react";

import "./Dropzone.css";

export interface DropzoneFile {
  name: string;
  url: string;
}

interface DropzoneFileProps extends DropzoneFile {
  onRemove: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}

const DropzoneFile = (props: DropzoneFileProps) => (
  <div className="filelist__item">
    <button
      className="filelist__delete-btn"
      onClick={props.onRemove}
      type="button"
    />
    <i className="filelist__icon fa fa-file-o" />
    <div className="filelist__name">{props.name}</div>
  </div>
);

export default DropzoneFile;



// WEBPACK FOOTER //
// ./src/components/Dropzone/File.tsx